function getSessionId(): string {
  const user = JSON.parse(window.localStorage.getItem('user') as string);
  let sid = null;
  if (user) sid = user.sid;

  return sid;
}

function getWxworkSessionId(): string {
  const user = JSON.parse(window.localStorage.getItem('user') as string);
  let sid = null;
  if (user) sid = user.sid;

  return sid;
}

function getQWUser(): Record<string, string> {
  const user = JSON.parse(window.localStorage.getItem('user') as string);
  return user || {};
}

function getCUser(): Record<string, string> {
  const user = JSON.parse(window.localStorage.getItem('c_user') as string);
  return user || {};
}

export default {
  getSessionId,
  getWxworkSessionId,
  getQWUser,
  getCUser
};
